module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_04-d9d98a4ffa9ce9acfae6238b2d2ef830.webp";